import http from "@/shared/services/http";

export const createArticle = (data: any) => http.post(`v1/articles`, data);
export const singleArticle = (id: any) => http.get(`v1/articles/byId/${id}`);
export const editArticle = (id: any, data: any) => http.put(`v1/articles/${id}`, data);
export const deleteArticle = (id: any) => http.delete(`v1/articles/${id}`);
export const listArticles = (params: any) => http.get(`v1/articles`, { params });